const ProductImage = ({ className, img }) => {
  return (
    <div className={` ${className}`}>
      <img
        src={img}
        className="w-full h-full object-contain"
        alt="product two"
      />
    </div>
  );
};

export default ProductImage;
